<div class="unlogged-form-page password-reset">
    <form class="box" [formGroup]="passwordResetFG" (ngSubmit)="resetPassword()">
        <h1 class="page-title text">
            Garantor
        </h1>
        <h2 class="page-description text">
            Reinicio de contraseña
        </h2>
        <mat-form-field class="garantor-form-field default-suffix" appearance="outline">
            <mat-label>Nueva contraseña</mat-label>
            <input matInput [type]="showPassword ? 'text' : 'password'" formControlName="password" required>
            <mat-error *ngIf="passwordResetFG.controls.password.hasError('required')">
                Por favor ingrese una nueva contraseña
            </mat-error>
            <button mat-icon-button matSuffix class="show-password-icon" type="button" (click)="showPassword = !showPassword; $event.stopPropagation()">
                <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
        </mat-form-field>
        <mat-form-field class="garantor-form-field default-suffix" appearance="outline">
            <mat-label>Confirmar contraseña</mat-label>
            <input matInput [type]="showPasswordConfirm ? 'text' : 'password'" formControlName="passwordConfirm" required>
            <mat-error *ngIf="passwordResetFG.controls.passwordConfirm.hasError('required')">
                Por favor ingrese una contraseña
            </mat-error>
            <mat-error *ngIf="passwordResetFG.controls.passwordConfirm.hasError('notEquals')">
                Las contraseñas no son iguales
            </mat-error>
            <button mat-icon-button matSuffix class="show-password-icon" type="button" (click)="showPasswordConfirm = !showPasswordConfirm; $event.stopPropagation()">
                <mat-icon>{{ showPasswordConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
        </mat-form-field>
        <div class="buttons-container">
            <button mat-button color="primary" class="garantor-button mini" [disabled]="!passwordResetFG.valid">
                Guardar
            </button>
        </div>
    </form>
</div>
